module.exports = __webpack_public_path__ + "img/BR.c3b6e773.png";